import React from "react";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import Table from "../../../components/lists/Table/Table";
import { Button, DatePicker } from "antd";
import { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import { useCubeQuery } from "../../../utils/hooks/useCubeQuery";
import useCubeClient from "../../../utils/cubejs-client";
import { usePublicationMany } from "../../../utils/api/publication";
import {
  exportToExcelPublishers,
  getPublisherDetails,
} from "../../../utils/helperfuctions";

const campaignColumns = [
  {
    title: "Campaign",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Total reads",
    dataIndex: "reads",
    key: "reads",
  },
  {
    title: "Total Revenue",
    dataIndex: "revenue",
    key: "revenue",
    render: (text) => parseFloat(text).toFixed(1),
  },
];

const Revenue = () => {
  const {user} = useCurrentUser();
  const cubejsApi = useCubeClient()

  const [startOfMonth, setStartOfMonth] = useState(dayjs().startOf("month"));
  const [endOfMonth, setEndOfMonth] = useState(dayjs().endOf("month"));

  // Create separate state variables for query
  const queryStart = useMemo(
    () => startOfMonth.format("YYYY-MM-DD"),
    [startOfMonth]
  );
  const queryEnd = useMemo(() => endOfMonth.format("YYYY-MM-DD"), [endOfMonth]);

  const { resultSet, error, isLoading } = useCubeQuery(
    {
      order: {
        "epom_data.totalCost": "desc",
      },
      measures: ["epom_data.totalCost", "epom_data.Reads"],
      dimensions: [
        "epom_data.publisherId",
        "epom_data.websiteId",
        "epom_data.campaignId",
      ],
      timeDimensions: [
        {
          dimension: "epom_data.Date",
          dateRange: [queryStart, queryEnd],
        },
      ],
    },
    { cubejsApi }
  );

  const { loading, errorPub, data } = usePublicationMany({
    perPage: 1000,
  });

  const publishers =
    !error && !isLoading && !loading && !errorPub && resultSet
      ? getPublisherDetails(
          data.PublicationMany.items,
          resultSet.loadResponse.results[0].data
        )
      : [];
  const websiteColumns = [
    {
      title: "Website",
      dataIndex: "website",
      key: "website",
    },
    {
      title: "Total reads",
      dataIndex: "reads",
      key: "reads",
    },
    {
      title: "Total Revenue",
      dataIndex: "revenue",
      key: "revenue",
      render: (text) => parseFloat(text).toFixed(1),
    },
  ];

  const expandedRowRender = (record) => {
    const expandedRowRender = (record) => (
      <Table
        columns={campaignColumns}
        data={record.campaignData}
        searchable={false}
      />
    );

    return (
      <Table
        columns={websiteColumns}
        data={record.websitedata}
        searchable={false}
        expandable={{ expandedRowRender }}
      />
    );
  };

  const columns = [
    {
      title: "Publisher",
      dataIndex: "publisher",
      key: "publisher",
    },
    {
      title: "Total reads",
      dataIndex: "reads",
      key: "reads",
    },
    {
      title: "Total Revenue",
      dataIndex: "revenue",
      key: "revenue",
      render: (text) => parseFloat(text).toFixed(1),
    },
  ];

  const onDateChange = (dates) => {
    // Update the start and end of month when a new date range is selected
    if (dates && dates.length === 2) {
      setStartOfMonth(dates[0]);
      setEndOfMonth(dates[1]);
    }
  };

  return (
    <div className="pb-4 bg-white rounded-lg shadow-lg py-2">
      <div className="px-2 sm:px-6 lg:px-4 py-4">
        <div className="sm:flex sm:items-center p-2">
          <div className="sm:flex-auto">
            <h1 className="text-lg leading-6 font-medium text-gray-900">
              Revenue
            </h1>
            <DatePicker.RangePicker
              allowClear={false}
              onChange={onDateChange}
              defaultValue={[startOfMonth, endOfMonth]}
            />
          </div>
        </div>
        <Table
          className="mt-4"
          columns={columns}
          data={publishers}
          searchable={false}
          expandable={{ expandedRowRender }}
          loading={isLoading || loading}
          footer={() => (
            <Button
              onClick={() =>
                exportToExcelPublishers(publishers, "WebsitesData")
              }
            >
              Export to Excel
            </Button>
          )}
        />
      </div>
    </div>
  );
};

export default Revenue;
